// import React, { useState, useEffect, useRef, useCallback } from "react";
// import axios from "axios";
// import config from "../config";
// import {
//   MdPrint,
//   MdDownload,
//   MdEmail,
//   MdRefresh,
//   MdTrendingUp,
//   MdAccountBalance,
//   MdListAlt,
//   MdBook,
//   MdSync,
//   MdClose,
//   MdWarning,
//   MdCheckCircle,
// } from "react-icons/md";

// const BASE_URL = config.baseURL;

// // ─── Brand Tokens ─────────────────────────────────────────────────────────────
// const C = {
//   accent: "#2E4053",
//   accentHover: "#1C2A3D",
//   accentLight: "#D1D8E0",
//   pageBg: "#EEF1F4",
//   cardBg: "#FFFFFF",
//   rowAlt: "#F7F8FA",
//   border: "#A6AAAD",
//   text: "#1F2937",
//   muted: "#34495E",
//   textLight: "#6B7280",
//   chipOnDark: "#D1D8E0",
//   success: "#10B981",
//   danger: "#EF4444",
//   warning: "#F59E0B",
//   purple: "#6366F1",
// };

// // ─── Auth ─────────────────────────────────────────────────────────────────────
// const authHeader = () => ({
//   Authorization: `Bearer ${localStorage.getItem("token")}`,
// });

// // ─── API ──────────────────────────────────────────────────────────────────────
// const REPORT_ENDPOINTS = {
//   income_statement: "income-statement",
//   balance_sheet: "balance-sheet",
//   trial_balance: "trial-balance",
//   ledger: "ledger",
// };

// const api = {
//   sync: (from, to) =>
//     axios.post(
//       `${BASE_URL}/api/financial-sync`,
//       { date_from: from || undefined, date_to: to || undefined },
//       { headers: authHeader() }
//     ),
//   report: (type, from, to) =>
//     axios.get(`${BASE_URL}/api/financial/${REPORT_ENDPOINTS[type]}`, {
//       params: { date_from: from, date_to: to },
//       headers: authHeader(),
//     }),
//   exportXlsx: (type, from, to) =>
//     fetch(
//       `${BASE_URL}/api/financial/export?report_type=${type}&date_from=${from}&date_to=${to}`,
//       { headers: authHeader() }
//     ),
//   email: (payload) =>
//     axios.post(`${BASE_URL}/api/financial/email`, payload, {
//       headers: authHeader(),
//     }),
// };

// // ─── Date Helpers ─────────────────────────────────────────────────────────────
// const isoDate = (d) => d.toISOString().split("T")[0];
// const now = () => new Date();
// const todayStr = () => isoDate(now());
// const firstOfYear = () => isoDate(new Date(now().getFullYear(), 0, 1));
// const firstOfMon = () =>
//   isoDate(new Date(now().getFullYear(), now().getMonth(), 1));
// const firstOfPrev = () =>
//   isoDate(new Date(now().getFullYear(), now().getMonth() - 1, 1));
// const lastOfPrev = () =>
//   isoDate(new Date(now().getFullYear(), now().getMonth(), 0));
// const firstOfQtr = () =>
//   isoDate(
//     new Date(now().getFullYear(), Math.floor(now().getMonth() / 3) * 3, 1)
//   );

// const QUICK_RANGES = [
//   { label: "This Month", from: firstOfMon(), to: todayStr() },
//   { label: "Last Month", from: firstOfPrev(), to: lastOfPrev() },
//   { label: "This Quarter", from: firstOfQtr(), to: todayStr() },
//   { label: "This Year", from: firstOfYear(), to: todayStr() },
// ];

// // ─── Formatters ───────────────────────────────────────────────────────────────
// const fmt = (n) =>
//   new Intl.NumberFormat("en-US", {
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//   }).format(n || 0);

// // ─── Base Styles ──────────────────────────────────────────────────────────────
// const S = {
//   page: { backgroundColor: C.pageBg, minHeight: "100vh", padding: 24 },
//   card: {
//     background: C.cardBg,
//     borderRadius: 12,
//     padding: 24,
//     boxShadow: "0 2px 10px rgba(0,0,0,0.07)",
//     marginBottom: 20,
//   },
//   label: {
//     fontSize: 11,
//     fontWeight: 700,
//     color: C.muted,
//     display: "block",
//     marginBottom: 4,
//     textTransform: "uppercase",
//     letterSpacing: 0.5,
//   },
//   input: {
//     border: `1px solid ${C.border}`,
//     borderRadius: 8,
//     padding: "9px 13px",
//     fontSize: 14,
//     width: "100%",
//     outline: "none",
//     boxSizing: "border-box",
//     color: C.text,
//     backgroundColor: C.cardBg,
//   },
//   table: { width: "100%", borderCollapse: "collapse", fontSize: 13 },
//   th: {
//     textAlign: "left",
//     padding: "11px 14px",
//     backgroundColor: C.accent,
//     color: C.chipOnDark,
//     fontWeight: 600,
//     fontSize: 11,
//     textTransform: "uppercase",
//     letterSpacing: 0.5,
//   },
//   thR: {
//     textAlign: "right",
//     padding: "11px 14px",
//     backgroundColor: C.accent,
//     color: C.chipOnDark,
//     fontWeight: 600,
//     fontSize: 11,
//     textTransform: "uppercase",
//     letterSpacing: 0.5,
//   },
//   td: {
//     padding: "10px 14px",
//     borderBottom: "1px solid #EEF0F2",
//     color: C.text,
//   },
//   tdR: {
//     padding: "10px 14px",
//     borderBottom: "1px solid #EEF0F2",
//     textAlign: "right",
//     color: C.text,
//   },
// };

// // ─── Atoms ────────────────────────────────────────────────────────────────────
// const Btn = ({
//   children,
//   color = C.accent,
//   hoverColor,
//   outlined,
//   onClick,
//   disabled,
//   style,
// }) => {
//   const [hov, setHov] = useState(false);
//   const hover = hoverColor || C.accentHover;
//   const base = outlined
//     ? {
//         border: `1.5px solid ${color}`,
//         backgroundColor: hov ? color + "15" : "transparent",
//         color,
//       }
//     : {
//         border: "none",
//         backgroundColor: disabled ? "#C5C9CD" : hov ? hover : color,
//         color: "#fff",
//       };
//   return (
//     <button
//       onClick={onClick}
//       disabled={disabled}
//       onMouseEnter={() => setHov(true)}
//       onMouseLeave={() => setHov(false)}
//       style={{
//         ...base,
//         padding: "9px 18px",
//         borderRadius: 8,
//         cursor: disabled ? "not-allowed" : "pointer",
//         fontSize: 13,
//         fontWeight: 600,
//         display: "flex",
//         alignItems: "center",
//         gap: 6,
//         transition: "all 0.15s",
//         whiteSpace: "nowrap",
//         ...style,
//       }}
//     >
//       {children}
//     </button>
//   );
// };

// const Divider = ({ label }) => (
//   <div
//     style={{
//       display: "flex",
//       alignItems: "center",
//       gap: 10,
//       margin: "18px 0 10px",
//     }}
//   >
//     <div style={{ flex: 1, height: 1, backgroundColor: C.accentLight }} />
//     <span
//       style={{
//         fontSize: 11,
//         fontWeight: 700,
//         color: C.muted,
//         textTransform: "uppercase",
//         letterSpacing: 1,
//       }}
//     >
//       {label}
//     </span>
//     <div style={{ flex: 1, height: 1, backgroundColor: C.accentLight }} />
//   </div>
// );

// // ─── KPI Strip ────────────────────────────────────────────────────────────────
// const KPI_CONFIG = {
//   income_statement: (d) => [
//     { label: "Revenue", value: fmt(d.revenue?.total), color: C.success },
//     { label: "Gross Profit", value: fmt(d.gross_profit), color: C.accent },
//     {
//       label: "Operating Income",
//       value: fmt(d.operating_income),
//       color: C.warning,
//     },
//     {
//       label: "Net Income",
//       value: fmt(d.net_income),
//       color: d.net_income >= 0 ? C.success : C.danger,
//     },
//     { label: "Net Margin", value: `${d.net_income_margin}%`, color: C.purple },
//   ],
//   balance_sheet: (d) => [
//     { label: "Total Assets", value: fmt(d.assets?.total), color: C.accent },
//     {
//       label: "Total Liabilities",
//       value: fmt(d.liabilities?.total),
//       color: C.danger,
//     },
//     { label: "Total Equity", value: fmt(d.equity?.total), color: C.success },
//     {
//       label: "Balanced",
//       value: d.is_balanced ? "✅ Yes" : "❌ No",
//       color: d.is_balanced ? C.success : C.danger,
//     },
//   ],
//   trial_balance: (d) => [
//     { label: "Total Debits", value: fmt(d.totals?.debit), color: C.accent },
//     { label: "Total Credits", value: fmt(d.totals?.credit), color: C.success },
//     {
//       label: "Balanced",
//       value: d.totals?.is_balanced ? "✅ Yes" : "❌ No",
//       color: d.totals?.is_balanced ? C.success : C.danger,
//     },
//   ],
// };

// const KPIStrip = ({ reportType, data }) => {
//   const cards = KPI_CONFIG[reportType]?.(data) ?? [];
//   if (!cards.length || !data) return null;
//   return (
//     <div
//       style={{ display: "flex", gap: 14, flexWrap: "wrap", marginBottom: 24 }}
//     >
//       {cards.map((c, i) => (
//         <div
//           key={i}
//           style={{
//             flex: "1 1 140px",
//             background: C.cardBg,
//             borderRadius: 10,
//             padding: "16px 18px",
//             borderTop: `3px solid ${c.color}`,
//             boxShadow: "0 1px 6px rgba(0,0,0,0.05)",
//           }}
//         >
//           <div
//             style={{
//               fontSize: 11,
//               color: C.muted,
//               fontWeight: 700,
//               textTransform: "uppercase",
//               letterSpacing: 0.5,
//               marginBottom: 6,
//             }}
//           >
//             {c.label}
//           </div>
//           <div style={{ fontSize: 19, fontWeight: 800, color: c.color }}>
//             {c.value}
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// // ─── Balance Sheet ────────────────────────────────────────────────────────────
// const BSSection = ({ title, items, total, tint }) => (
//   <div style={{ marginBottom: 16 }}>
//     <div
//       style={{
//         fontWeight: 700,
//         color: C.accent,
//         padding: "7px 0",
//         borderBottom: `2px solid ${C.accentLight}`,
//         marginBottom: 6,
//         fontSize: 11,
//         textTransform: "uppercase",
//         letterSpacing: 0.5,
//       }}
//     >
//       {title}
//     </div>
//     {items?.map((item, i) => (
//       <div
//         key={i}
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           padding: "6px 10px",
//           backgroundColor: i % 2 === 0 ? tint : C.cardBg,
//         }}
//       >
//         <span style={{ color: C.muted, fontSize: 13 }}>
//           {item.code} — {item.name}
//         </span>
//         <span style={{ fontWeight: 600, fontSize: 13 }}>
//           {fmt(item.balance)}
//         </span>
//       </div>
//     ))}
//     <div
//       style={{
//         display: "flex",
//         justifyContent: "space-between",
//         padding: "8px 10px",
//         backgroundColor: tint,
//         borderRadius: 6,
//         marginTop: 4,
//       }}
//     >
//       <span style={{ fontWeight: 700, fontSize: 13 }}>Total {title}</span>
//       <span style={{ fontWeight: 800, fontSize: 14 }}>{fmt(total)}</span>
//     </div>
//   </div>
// );

// const TotalBar = ({ label, value, dark }) => (
//   <div
//     style={{
//       display: "flex",
//       justifyContent: "space-between",
//       padding: "12px 16px",
//       backgroundColor: dark ? C.accent : C.accentLight,
//       borderRadius: 8,
//       marginTop: 8,
//     }}
//   >
//     <span
//       style={{ fontWeight: 700, fontSize: 14, color: dark ? "#fff" : C.text }}
//     >
//       {label}
//     </span>
//     <span
//       style={{ fontWeight: 800, fontSize: 16, color: dark ? "#fff" : C.text }}
//     >
//       {fmt(value)}
//     </span>
//   </div>
// );

// const BalanceSheetView = ({ data }) =>
//   !data ? null : (
//     <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 28 }}>
//       <div>
//         <Divider label="Assets" />
//         <BSSection
//           title="Current Assets"
//           items={data.assets?.current?.items}
//           total={data.assets?.current?.total}
//           tint="#EFF6FF"
//         />
//         <BSSection
//           title="Fixed Assets"
//           items={data.assets?.fixed?.items}
//           total={data.assets?.fixed?.total}
//           tint="#EFF6FF"
//         />
//         <TotalBar label="TOTAL ASSETS" value={data.assets?.total} dark />
//       </div>
//       <div>
//         <Divider label="Liabilities & Equity" />
//         <BSSection
//           title="Current Liabilities"
//           items={data.liabilities?.current?.items}
//           total={data.liabilities?.current?.total}
//           tint="#FEF2F2"
//         />
//         <BSSection
//           title="Long-Term Liabilities"
//           items={data.liabilities?.long_term?.items}
//           total={data.liabilities?.long_term?.total}
//           tint="#FEF2F2"
//         />
//         <BSSection
//           title="Equity"
//           items={data.equity?.items}
//           total={data.equity?.total}
//           tint="#ECFDF5"
//         />
//         <TotalBar
//           label="TOTAL LIABILITIES + EQUITY"
//           value={data.total_liabilities_and_equity}
//           dark
//         />
//       </div>
//     </div>
//   );

// // ─── Income Statement ─────────────────────────────────────────────────────────
// const ISSection = ({ label, items, total, color }) => (
//   <>
//     <Divider label={label} />
//     {items?.map((item, i) => (
//       <div
//         key={i}
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           padding: "6px 18px",
//         }}
//       >
//         <span style={{ color: C.muted, fontSize: 13 }}>
//           {item.code} — {item.name}
//         </span>
//         <span style={{ fontWeight: 500, fontSize: 13 }}>
//           {fmt(item.balance)}
//         </span>
//       </div>
//     ))}
//     <div
//       style={{
//         display: "flex",
//         justifyContent: "space-between",
//         padding: "9px 10px",
//         backgroundColor: color,
//         borderRadius: 6,
//         marginTop: 4,
//       }}
//     >
//       <span style={{ fontWeight: 700, fontSize: 13, color: "#fff" }}>
//         Total {label}
//       </span>
//       <span style={{ fontWeight: 800, fontSize: 14, color: "#fff" }}>
//         {fmt(total)}
//       </span>
//     </div>
//   </>
// );

// const IncomeStatementView = ({ data }) =>
//   !data ? null : (
//     <div style={{ maxWidth: 620, margin: "0 auto" }}>
//       <ISSection
//         label="Revenue"
//         items={data.revenue?.items}
//         total={data.revenue?.total}
//         color={C.success}
//       />
//       <ISSection
//         label="Cost of Goods Sold"
//         items={data.cogs?.items}
//         total={data.cogs?.total}
//         color={C.danger}
//       />
//       <div
//         style={{
//           border: `2px solid ${C.accent}`,
//           borderRadius: 10,
//           padding: "14px 18px",
//           display: "flex",
//           justifyContent: "space-between",
//           margin: "18px 0",
//         }}
//       >
//         <span style={{ fontWeight: 700, fontSize: 15, color: C.accent }}>
//           GROSS PROFIT
//         </span>
//         <span style={{ fontWeight: 800, fontSize: 17, color: C.accent }}>
//           {fmt(data.gross_profit)}
//         </span>
//       </div>
//       <ISSection
//         label="Operating Expenses"
//         items={data.operating_expenses?.items}
//         total={data.operating_expenses?.total}
//         color={C.warning}
//       />
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           padding: "9px 10px",
//           backgroundColor: C.purple,
//           borderRadius: 6,
//           marginBottom: 6,
//         }}
//       >
//         <span style={{ fontWeight: 700, fontSize: 13, color: "#fff" }}>
//           Operating Income
//         </span>
//         <span style={{ fontWeight: 800, fontSize: 14, color: "#fff" }}>
//           {fmt(data.operating_income)}
//         </span>
//       </div>
//       {data.other_expenses?.items?.length > 0 && (
//         <ISSection
//           label="Other Expenses"
//           items={data.other_expenses?.items}
//           total={data.other_expenses?.total}
//           color={C.muted}
//         />
//       )}
//       <div
//         style={{
//           padding: "16px 20px",
//           backgroundColor: data.net_income >= 0 ? C.success : C.danger,
//           borderRadius: 10,
//           display: "flex",
//           justifyContent: "space-between",
//           marginTop: 18,
//           color: "#fff",
//         }}
//       >
//         <span style={{ fontWeight: 700, fontSize: 17 }}>NET INCOME</span>
//         <div style={{ textAlign: "right" }}>
//           <div style={{ fontWeight: 800, fontSize: 22 }}>
//             {fmt(data.net_income)}
//           </div>
//           <div style={{ fontSize: 12, opacity: 0.85 }}>
//             Margin: {data.net_income_margin}%
//           </div>
//         </div>
//       </div>
//     </div>
//   );

// // ─── Trial Balance ────────────────────────────────────────────────────────────
// const TrialBalanceView = ({ data }) =>
//   !data ? null : (
//     <table style={S.table}>
//       <thead>
//         <tr>
//           <th style={S.th}>Code</th>
//           <th style={S.th}>Account</th>
//           <th style={S.th}>Type</th>
//           <th style={S.thR}>Debit</th>
//           <th style={S.thR}>Credit</th>
//         </tr>
//       </thead>
//       <tbody>
//         {data.rows?.map((row, i) => (
//           <tr
//             key={i}
//             style={{ backgroundColor: i % 2 === 0 ? C.rowAlt : C.cardBg }}
//           >
//             <td style={S.td}>{row.code}</td>
//             <td style={S.td}>{row.name}</td>
//             <td style={S.td}>
//               <span
//                 style={{
//                   fontSize: 11,
//                   padding: "2px 8px",
//                   borderRadius: 10,
//                   backgroundColor: C.accentLight,
//                   color: C.accent,
//                   fontWeight: 600,
//                 }}
//               >
//                 {row.type}
//               </span>
//             </td>
//             <td style={S.tdR}>
//               {row.total_debit > 0 ? fmt(row.total_debit) : "—"}
//             </td>
//             <td style={S.tdR}>
//               {row.total_credit > 0 ? fmt(row.total_credit) : "—"}
//             </td>
//           </tr>
//         ))}
//       </tbody>
//       <tfoot>
//         <tr style={{ backgroundColor: C.accent }}>
//           <td
//             colSpan={3}
//             style={{
//               ...S.td,
//               fontWeight: 700,
//               color: "#fff",
//               borderBottom: "none",
//             }}
//           >
//             TOTALS
//           </td>
//           <td
//             style={{
//               ...S.tdR,
//               fontWeight: 800,
//               color: "#fff",
//               borderBottom: "none",
//             }}
//           >
//             {fmt(data.totals?.debit)}
//           </td>
//           <td
//             style={{
//               ...S.tdR,
//               fontWeight: 800,
//               color: "#fff",
//               borderBottom: "none",
//             }}
//           >
//             {fmt(data.totals?.credit)}
//           </td>
//         </tr>
//       </tfoot>
//     </table>
//   );

// // ─── General Ledger ───────────────────────────────────────────────────────────
// const LedgerView = ({ data }) =>
//   !data ? null : (
//     <table style={S.table}>
//       <thead>
//         <tr>
//           <th style={S.th}>Date</th>
//           <th style={S.th}>Reference</th>
//           <th style={S.th}>Description</th>
//           <th style={S.thR}>Debit</th>
//           <th style={S.thR}>Credit</th>
//           <th style={S.thR}>Balance</th>
//         </tr>
//       </thead>
//       <tbody>
//         {data.rows?.map((row, i) => (
//           <tr
//             key={i}
//             style={{ backgroundColor: i % 2 === 0 ? C.rowAlt : C.cardBg }}
//           >
//             <td style={S.td}>{row.entry_date}</td>
//             <td style={S.td}>{row.reference}</td>
//             <td style={S.td}>{row.description}</td>
//             <td style={S.tdR}>{row.debit > 0 ? fmt(row.debit) : "—"}</td>
//             <td style={S.tdR}>{row.credit > 0 ? fmt(row.credit) : "—"}</td>
//             <td
//               style={{
//                 ...S.tdR,
//                 fontWeight: 600,
//                 color: row.running_balance >= 0 ? C.success : C.danger,
//               }}
//             >
//               {fmt(row.running_balance)}
//             </td>
//           </tr>
//         ))}
//       </tbody>
//     </table>
//   );

// // ─── Report Router ────────────────────────────────────────────────────────────
// const ReportView = ({ type, data }) =>
//   ({
//     income_statement: <IncomeStatementView data={data} />,
//     balance_sheet: <BalanceSheetView data={data} />,
//     trial_balance: <TrialBalanceView data={data} />,
//     ledger: <LedgerView data={data} />,
//   }[type] ?? null);

// // ─── Email Modal ──────────────────────────────────────────────────────────────
// const EmailModal = ({ onClose, onSend }) => {
//   const [email, setEmail] = useState("");
//   const [message, setMessage] = useState("");
//   const [busy, setBusy] = useState(false);
//   const send = async () => {
//     if (!email) return;
//     setBusy(true);
//     await onSend(email, message);
//     setBusy(false);
//     onClose();
//   };
//   return (
//     <div
//       style={{
//         position: "fixed",
//         inset: 0,
//         backgroundColor: "rgba(0,0,0,0.45)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         zIndex: 1000,
//       }}
//     >
//       <div
//         style={{
//           background: C.cardBg,
//           borderRadius: 14,
//           padding: 32,
//           width: 440,
//           boxShadow: "0 24px 64px rgba(0,0,0,0.22)",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             marginBottom: 22,
//           }}
//         >
//           <h3
//             style={{ margin: 0, color: C.text, fontSize: 16, fontWeight: 700 }}
//           >
//             Send Report via Email
//           </h3>
//           <button
//             onClick={onClose}
//             style={{
//               background: "none",
//               border: "none",
//               cursor: "pointer",
//               color: C.muted,
//               fontSize: 20,
//               display: "flex",
//             }}
//           >
//             <MdClose />
//           </button>
//         </div>
//         <label style={S.label}>Recipient *</label>
//         <input
//           type="email"
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//           style={{ ...S.input, marginBottom: 14 }}
//           placeholder="example@company.com"
//         />
//         <label style={S.label}>Message (optional)</label>
//         <textarea
//           value={message}
//           onChange={(e) => setMessage(e.target.value)}
//           style={{
//             ...S.input,
//             height: 80,
//             resize: "vertical",
//             marginBottom: 20,
//           }}
//           placeholder="Please find attached..."
//         />
//         <div style={{ display: "flex", gap: 10 }}>
//           <Btn onClick={send} disabled={busy || !email}>
//             {busy ? "Sending…" : "Send"}
//           </Btn>
//           <Btn onClick={onClose} color={C.muted}>
//             Cancel
//           </Btn>
//         </div>
//       </div>
//     </div>
//   );
// };

// // ─── Tabs Config ──────────────────────────────────────────────────────────────
// const TABS = [
//   {
//     key: "income_statement",
//     label: "Income Statement",
//     icon: <MdTrendingUp />,
//   },
//   { key: "balance_sheet", label: "Balance Sheet", icon: <MdAccountBalance /> },
//   { key: "trial_balance", label: "Trial Balance", icon: <MdListAlt /> },
//   { key: "ledger", label: "General Ledger", icon: <MdBook /> },
// ];

// // ─── Loading States ───────────────────────────────────────────────────────────
// const LOAD_STEPS = ["syncing", "loading"];

// const LoadingCard = ({ step }) => (
//   <div style={{ ...S.card, textAlign: "center", padding: 60 }}>
//     <div
//       style={{
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         gap: 14,
//       }}
//     >
//       <MdSync
//         style={{
//           fontSize: 36,
//           color: C.accent,
//           animation: "spin 0.9s linear infinite",
//         }}
//       />
//       <div>
//         <div
//           style={{
//             fontWeight: 700,
//             color: C.text,
//             fontSize: 15,
//             marginBottom: 4,
//           }}
//         >
//           {step === "syncing" ? "Syncing data…" : "Building report…"}
//         </div>
//         <div style={{ fontSize: 12, color: C.muted }}>
//           {step === "syncing"
//             ? "Pulling latest transactions from your backend for the selected period"
//             : "Calculating balances and generating your financial report"}
//         </div>
//       </div>
//       {/* Step indicator */}
//       <div
//         style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 8 }}
//       >
//         {LOAD_STEPS.map((s, i) => (
//           <React.Fragment key={s}>
//             <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
//               <div
//                 style={{
//                   width: 24,
//                   height: 24,
//                   borderRadius: "50%",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   fontSize: 12,
//                   fontWeight: 700,
//                   backgroundColor:
//                     s === step
//                       ? C.accent
//                       : LOAD_STEPS.indexOf(step) > i
//                       ? C.success
//                       : C.accentLight,
//                   color:
//                     s === step || LOAD_STEPS.indexOf(step) > i
//                       ? "#fff"
//                       : C.muted,
//                 }}
//               >
//                 {LOAD_STEPS.indexOf(step) > i ? "✓" : i + 1}
//               </div>
//               <span
//                 style={{
//                   fontSize: 12,
//                   fontWeight: 600,
//                   color:
//                     s === step
//                       ? C.accent
//                       : LOAD_STEPS.indexOf(step) > i
//                       ? C.success
//                       : C.muted,
//                   textTransform: "capitalize",
//                 }}
//               >
//                 {s === "syncing" ? "Sync" : "Report"}
//               </span>
//             </div>
//             {i < LOAD_STEPS.length - 1 && (
//               <div
//                 style={{
//                   width: 32,
//                   height: 2,
//                   backgroundColor:
//                     LOAD_STEPS.indexOf(step) > i ? C.success : C.accentLight,
//                   borderRadius: 1,
//                 }}
//               />
//             )}
//           </React.Fragment>
//         ))}
//       </div>
//     </div>
//     <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
//   </div>
// );

// // ─── Main Page ────────────────────────────────────────────────────────────────
// const FinancialReports = () => {
//   const [reportType, setReportType] = useState("income_statement");
//   const [dateFrom, setDateFrom] = useState(firstOfYear());
//   const [dateTo, setDateTo] = useState(todayStr());
//   const [data, setData] = useState(null);
//   const [loadStep, setLoadStep] = useState(null); // null | "syncing" | "loading"
//   const [error, setError] = useState("");
//   const [syncInfo, setSyncInfo] = useState(null); // last sync summary shown in header
//   const [showEmail, setShowEmail] = useState(false);
//   const [toast, setToast] = useState(null);
//   const printRef = useRef();

//   const showToast = (msg, isError = false) => {
//     setToast({ msg, isError });
//     setTimeout(() => setToast(null), 3500);
//   };

//   // ── Core: sync then fetch ──────────────────────────────────────────────────
//   const generate = useCallback(
//     async (type = reportType, from = dateFrom, to = dateTo) => {
//       setError("");
//       setData(null);
//       setSyncInfo(null);

//       // Step 1 — sync
//       setLoadStep("syncing");
//       try {
//         const syncRes = await api.sync(from, to);
//         const summary = syncRes.data?.summary;
//         setSyncInfo(summary); // e.g. { total_synced: 14, total_errors: 0 }
//       } catch {
//         // sync failure is non-fatal — still attempt to load cached data
//       }

//       // Step 2 — fetch report
//       setLoadStep("loading");
//       try {
//         const res = await api.report(type, from, to);
//         console.log("Report data:", res.data);
//         setData(res.data.data);
//       } catch (e) {
//         setError(e?.response?.data?.error || "Failed to load report");
//       } finally {
//         setLoadStep(null);
//       }
//     },
//     [reportType, dateFrom, dateTo]
//   );

//   // Auto-generate on tab switch
//   useEffect(() => {
//     generate(reportType, dateFrom, dateTo);
//   }, [reportType]);

//   const handleExport = async () => {
//     const res = await api.exportXlsx(reportType, dateFrom, dateTo);
//     const blob = await res.blob();
//     Object.assign(document.createElement("a"), {
//       href: URL.createObjectURL(blob),
//       download: `${reportType}_${dateFrom}_${dateTo}.xlsx`,
//     }).click();
//   };

//   const handleEmail = async (email, message) => {
//     await api.email({
//       report_type: reportType,
//       date_from: dateFrom,
//       date_to: dateTo,
//       email,
//       message,
//     });
//     showToast("Report sent successfully!");
//   };

//   const handlePrint = () => {
//     const w = window.open("", "_blank");
//     w.document.write(
//       `<html><head><title>${reportType}</title><style>body{font-family:Arial,sans-serif;padding:20px}*{box-sizing:border-box}@media print{button{display:none}}</style></head><body>${printRef.current?.innerHTML}</body></html>`
//     );
//     w.document.close();
//     w.print();
//   };

//   const isLoading = loadStep !== null;

//   return (
//     <div style={S.page}>
//       {/* Toast */}
//       {toast && (
//         <div
//           style={{
//             position: "fixed",
//             top: 20,
//             right: 20,
//             zIndex: 9999,
//             backgroundColor: toast.isError ? C.danger : C.success,
//             color: "#fff",
//             padding: "12px 22px",
//             borderRadius: 8,
//             fontWeight: 600,
//             boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
//             fontSize: 14,
//             display: "flex",
//             alignItems: "center",
//             gap: 8,
//           }}
//         >
//           {toast.isError ? <MdWarning /> : <MdCheckCircle />} {toast.msg}
//         </div>
//       )}

//       {/* ── Header ───────────────────────────────────────────────────────────── */}
//       <div
//         style={{
//           ...S.card,
//           backgroundColor: C.accent,
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           flexWrap: "wrap",
//           gap: 14,
//           borderRadius: 14,
//         }}
//       >
//         <div>
//           <h1
//             style={{ fontSize: 20, fontWeight: 700, color: "#fff", margin: 0 }}
//           >
//             📊 Financial Reports
//           </h1>
//           <p style={{ color: C.chipOnDark, margin: "4px 0 0", fontSize: 12 }}>
//             {dateFrom} → {dateTo}
//             {syncInfo && (
//               <span
//                 style={{
//                   marginLeft: 12,
//                   backgroundColor: "rgba(255,255,255,0.15)",
//                   padding: "2px 10px",
//                   borderRadius: 10,
//                   fontSize: 11,
//                 }}
//               >
//                 ✅ {syncInfo.total_synced ?? "—"} records synced
//                 {syncInfo.total_errors > 0 &&
//                   ` · ⚠️ ${syncInfo.total_errors} errors`}
//               </span>
//             )}
//           </p>
//         </div>
//         <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
//           <Btn
//             onClick={() => generate()}
//             disabled={isLoading}
//             color={C.accentHover}
//             hoverColor="#111C28"
//           >
//             <MdRefresh
//               style={{
//                 animation: isLoading ? "spin 0.9s linear infinite" : "none",
//               }}
//             />
//             {isLoading
//               ? loadStep === "syncing"
//                 ? "Syncing…"
//                 : "Loading…"
//               : "Refresh"}
//           </Btn>
//           <Btn onClick={handleExport} color="#0E7C5A" hoverColor="#0A6148">
//             <MdDownload /> Export
//           </Btn>
//           <Btn onClick={handlePrint} color="#4B3DA8" hoverColor="#3B2E88">
//             <MdPrint /> Print
//           </Btn>
//           <Btn
//             onClick={() => setShowEmail(true)}
//             color="#A0610A"
//             hoverColor="#7D4C08"
//           >
//             <MdEmail /> Email
//           </Btn>
//         </div>
//       </div>

//       {/* ── Filters ──────────────────────────────────────────────────────────── */}
//       <div style={S.card}>
//         <div
//           style={{
//             display: "flex",
//             gap: 14,
//             flexWrap: "wrap",
//             alignItems: "flex-end",
//           }}
//         >
//           <div style={{ flex: "1 1 150px" }}>
//             <label style={S.label}>From</label>
//             <input
//               type="date"
//               value={dateFrom}
//               onChange={(e) => setDateFrom(e.target.value)}
//               style={S.input}
//             />
//           </div>
//           <div style={{ flex: "1 1 150px" }}>
//             <label style={S.label}>To</label>
//             <input
//               type="date"
//               value={dateTo}
//               onChange={(e) => setDateTo(e.target.value)}
//               style={S.input}
//             />
//           </div>
//           <div style={{ flex: "2 1 260px" }}>
//             <label style={S.label}>Quick Range</label>
//             <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
//               {QUICK_RANGES.map((r, i) => (
//                 <button
//                   key={i}
//                   onClick={() => {
//                     setDateFrom(r.from);
//                     setDateTo(r.to);
//                   }}
//                   style={{
//                     padding: "7px 12px",
//                     border: `1px solid ${C.border}`,
//                     borderRadius: 6,
//                     cursor: "pointer",
//                     fontSize: 12,
//                     fontWeight: 600,
//                     backgroundColor: "#F8F9FB",
//                     color: C.muted,
//                   }}
//                 >
//                   {r.label}
//                 </button>
//               ))}
//             </div>
//           </div>
//           <Btn
//             onClick={() => generate(reportType, dateFrom, dateTo)}
//             disabled={isLoading}
//             style={{ padding: "9px 28px" }}
//           >
//             <MdSync
//               style={{
//                 animation: isLoading ? "spin 0.9s linear infinite" : "none",
//               }}
//             />
//             {isLoading
//               ? loadStep === "syncing"
//                 ? "Syncing…"
//                 : "Loading…"
//               : "Generate"}
//           </Btn>
//         </div>
//       </div>

//       {/* ── Tabs ─────────────────────────────────────────────────────────────── */}
//       <div
//         style={{
//           display: "flex",
//           gap: 2,
//           marginBottom: 18,
//           borderBottom: `2px solid ${C.accentLight}`,
//         }}
//       >
//         {TABS.map((tab) => (
//           <button
//             key={tab.key}
//             onClick={() => !isLoading && setReportType(tab.key)}
//             style={{
//               padding: "10px 18px",
//               border: "none",
//               cursor: isLoading ? "not-allowed" : "pointer",
//               fontSize: 13,
//               fontWeight: 600,
//               backgroundColor: "transparent",
//               borderBottom:
//                 reportType === tab.key
//                   ? `3px solid ${C.accent}`
//                   : "3px solid transparent",
//               color: reportType === tab.key ? C.accent : C.muted,
//               display: "flex",
//               alignItems: "center",
//               gap: 6,
//               transition: "all 0.15s",
//               marginBottom: -2,
//             }}
//           >
//             {tab.icon} {tab.label}
//           </button>
//         ))}
//       </div>

//       {/* ── Content ──────────────────────────────────────────────────────────── */}
//       <div ref={printRef}>
//         {isLoading && <LoadingCard step={loadStep} />}

//         {!isLoading && error && (
//           <div
//             style={{
//               ...S.card,
//               backgroundColor: "#FEF2F2",
//               color: C.danger,
//               border: `1px solid #FECACA`,
//               display: "flex",
//               alignItems: "center",
//               gap: 10,
//             }}
//           >
//             <MdWarning style={{ fontSize: 20, flexShrink: 0 }} /> {error}
//           </div>
//         )}

//         {!isLoading && !error && data && (
//           <div style={S.card}>
//             <KPIStrip reportType={reportType} data={data} />
//             <ReportView type={reportType} data={data} />
//           </div>
//         )}
//       </div>

//       {showEmail && (
//         <EmailModal onClose={() => setShowEmail(false)} onSend={handleEmail} />
//       )}

//       <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
//     </div>
//   );
// };

// export default FinancialReports;
import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import config from "../config";
import {
  MdPrint,
  MdDownload,
  MdEmail,
  MdRefresh,
  MdTrendingUp,
  MdAccountBalance,
  MdListAlt,
  MdBook,
  MdSync,
  MdClose,
  MdWarning,
  MdCheckCircle,
  MdPeople,
  MdStore,
  MdDonutLarge,
  MdTableChart,
} from "react-icons/md";

const BASE_URL = config.baseURL;

const C = {
  accent: "#2E4053",
  accentHover: "#1C2A3D",
  accentLight: "#D1D8E0",
  pageBg: "#EEF1F4",
  cardBg: "#FFFFFF",
  rowAlt: "#F7F8FA",
  border: "#A6AAAD",
  text: "#1F2937",
  muted: "#34495E",
  chipOnDark: "#D1D8E0",
  success: "#10B981",
  danger: "#EF4444",
  warning: "#F59E0B",
  purple: "#6366F1",
  blue: "#3B82F6",
};

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

const REPORT_ENDPOINTS = {
  income_statement: "income-statement",
  balance_sheet: "balance-sheet",
  trial_balance: "trial-balance",
  ledger: "ledger",
  ar_aging: "ar-aging",
  ap_aging: "ap-aging",
  budget_vs_actual: "budget-vs-actual",
  cost_centers: "cost-centers",
};

const api = {
  report: (type, params = {}) =>
    axios.get(`${BASE_URL}/api/financial/${REPORT_ENDPOINTS[type]}`, {
      params,
      headers: authHeader(),
    }),
  exportXlsx: (type, from, to) =>
    fetch(
      `${BASE_URL}/api/financial/export?report_type=${type}&date_from=${from}&date_to=${to}`,
      { headers: authHeader() }
    ),
  email: (payload) =>
    axios.post(`${BASE_URL}/api/financial/email`, payload, {
      headers: authHeader(),
    }),
};

const isoDate = (d) => d.toISOString().split("T")[0];
const now = () => new Date();
const todayStr = () => isoDate(now());
const firstOfYear = () => isoDate(new Date(now().getFullYear(), 0, 1));
const firstOfMon = () =>
  isoDate(new Date(now().getFullYear(), now().getMonth(), 1));
const firstOfPrev = () =>
  isoDate(new Date(now().getFullYear(), now().getMonth() - 1, 1));
const lastOfPrev = () =>
  isoDate(new Date(now().getFullYear(), now().getMonth(), 0));
const firstOfQtr = () =>
  isoDate(
    new Date(now().getFullYear(), Math.floor(now().getMonth() / 3) * 3, 1)
  );

const QUICK_RANGES = [
  { label: "This Month", from: firstOfMon(), to: todayStr() },
  { label: "Last Month", from: firstOfPrev(), to: lastOfPrev() },
  { label: "This Quarter", from: firstOfQtr(), to: todayStr() },
  { label: "This Year", from: firstOfYear(), to: todayStr() },
];

const fmt = (n) =>
  new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n || 0);
const fmtPct = (n) => `${n >= 0 ? "+" : ""}${n}%`;

const S = {
  page: { backgroundColor: C.pageBg, minHeight: "100vh", padding: 24 },
  card: {
    background: C.cardBg,
    borderRadius: 12,
    padding: 24,
    boxShadow: "0 2px 10px rgba(0,0,0,0.07)",
    marginBottom: 20,
  },
  label: {
    fontSize: 11,
    fontWeight: 700,
    color: C.muted,
    display: "block",
    marginBottom: 4,
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  input: {
    border: `1px solid ${C.border}`,
    borderRadius: 8,
    padding: "9px 13px",
    fontSize: 14,
    width: "100%",
    outline: "none",
    boxSizing: "border-box",
    color: C.text,
    backgroundColor: C.cardBg,
  },
  table: { width: "100%", borderCollapse: "collapse", fontSize: 13 },
  th: {
    textAlign: "left",
    padding: "11px 14px",
    backgroundColor: C.accent,
    color: C.chipOnDark,
    fontWeight: 600,
    fontSize: 11,
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  thR: {
    textAlign: "right",
    padding: "11px 14px",
    backgroundColor: C.accent,
    color: C.chipOnDark,
    fontWeight: 600,
    fontSize: 11,
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  td: {
    padding: "10px 14px",
    borderBottom: "1px solid #EEF0F2",
    color: C.text,
  },
  tdR: {
    padding: "10px 14px",
    borderBottom: "1px solid #EEF0F2",
    textAlign: "right",
    color: C.text,
  },
};

// ── Tabs ──────────────────────────────────────────────────────────────────────
const TABS = [
  {
    key: "income_statement",
    label: "Income Statement",
    icon: <MdTrendingUp />,
    group: "core",
  },
  {
    key: "balance_sheet",
    label: "Balance Sheet",
    icon: <MdAccountBalance />,
    group: "core",
  },
  {
    key: "trial_balance",
    label: "Trial Balance",
    icon: <MdListAlt />,
    group: "core",
  },
  { key: "ledger", label: "General Ledger", icon: <MdBook />, group: "core" },
  { key: "ar_aging", label: "AR Aging", icon: <MdPeople />, group: "advanced" },
  { key: "ap_aging", label: "AP Aging", icon: <MdStore />, group: "advanced" },
  {
    key: "cost_centers",
    label: "Cost Centers",
    icon: <MdDonutLarge />,
    group: "advanced",
  },
  {
    key: "budget_vs_actual",
    label: "Budget vs Actual",
    icon: <MdTableChart />,
    group: "advanced",
  },
];

// ── Atoms ─────────────────────────────────────────────────────────────────────
const Btn = ({
  children,
  color = C.accent,
  hoverColor,
  onClick,
  disabled,
  style,
}) => {
  const [hov, setHov] = useState(false);
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        border: "none",
        backgroundColor: disabled
          ? "#C5C9CD"
          : hov
          ? hoverColor || C.accentHover
          : color,
        color: "#fff",
        padding: "9px 18px",
        borderRadius: 8,
        cursor: disabled ? "not-allowed" : "pointer",
        fontSize: 13,
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
        gap: 6,
        transition: "all 0.15s",
        whiteSpace: "nowrap",
        ...style,
      }}
    >
      {children}
    </button>
  );
};

const Divider = ({ label }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: 10,
      margin: "18px 0 10px",
    }}
  >
    <div style={{ flex: 1, height: 1, backgroundColor: C.accentLight }} />
    <span
      style={{
        fontSize: 11,
        fontWeight: 700,
        color: C.muted,
        textTransform: "uppercase",
        letterSpacing: 1,
      }}
    >
      {label}
    </span>
    <div style={{ flex: 1, height: 1, backgroundColor: C.accentLight }} />
  </div>
);

const SourceBadge = ({ source }) =>
  source ? (
    <span
      style={{
        fontSize: 10,
        padding: "2px 8px",
        borderRadius: 10,
        marginLeft: 8,
        backgroundColor: source === "coa" ? "#ECFDF5" : "#FEF3C7",
        color: source === "coa" ? "#065F46" : "#92400E",
        fontWeight: 600,
      }}
    >
      {source === "coa" ? "COA / Journal entries" : "Direct from source tables"}
    </span>
  ) : null;

// ── KPI strip ─────────────────────────────────────────────────────────────────
const KPI_CONFIG = {
  income_statement: (d) => [
    { label: "Revenue", value: fmt(d.revenue?.total), color: C.success },
    { label: "COGS", value: fmt(d.cogs?.total), color: C.danger },
    { label: "Gross Profit", value: fmt(d.gross_profit), color: C.accent },
    {
      label: "Operating Income",
      value: fmt(d.operating_income),
      color: C.warning,
    },
    {
      label: "Net Income",
      value: fmt(d.net_income),
      color: d.net_income >= 0 ? C.success : C.danger,
    },
    { label: "Net Margin", value: `${d.net_income_margin}%`, color: C.purple },
  ],
  balance_sheet: (d) => [
    { label: "Total Assets", value: fmt(d.assets?.total), color: C.accent },
    {
      label: "Total Liabilities",
      value: fmt(d.liabilities?.total),
      color: C.danger,
    },
    { label: "Total Equity", value: fmt(d.equity?.total), color: C.success },
    {
      label: "Balanced",
      value: d.is_balanced ? "✅ Yes" : "❌ No",
      color: d.is_balanced ? C.success : C.danger,
    },
  ],
  trial_balance: (d) => [
    { label: "Total Debits", value: fmt(d.totals?.debit), color: C.accent },
    { label: "Total Credits", value: fmt(d.totals?.credit), color: C.success },
    {
      label: "Balanced",
      value: d.totals?.is_balanced ? "✅ Yes" : "❌ No",
      color: d.totals?.is_balanced ? C.success : C.danger,
    },
  ],
  ar_aging: (d) => [
    {
      label: "Total Outstanding",
      value: fmt(d.total_outstanding),
      color: C.danger,
    },
    { label: "Current", value: fmt(d.current?.total), color: C.success },
    { label: "1-30 Days", value: fmt(d.d1_30?.total), color: C.warning },
    { label: "31-60 Days", value: fmt(d.d31_60?.total), color: "#F97316" },
    { label: "90+ Days", value: fmt(d.d90plus?.total), color: C.danger },
  ],
  ap_aging: (d) => [
    {
      label: "Total Payable",
      value: fmt(d.total_outstanding),
      color: C.danger,
    },
    { label: "Current", value: fmt(d.current?.total), color: C.success },
    { label: "1-30 Days", value: fmt(d.d1_30?.total), color: C.warning },
    { label: "31-60 Days", value: fmt(d.d31_60?.total), color: "#F97316" },
    { label: "90+ Days", value: fmt(d.d90plus?.total), color: C.danger },
  ],
  budget_vs_actual: (d) => [
    { label: "Total Budget", value: fmt(d.total_budget), color: C.accent },
    { label: "Total Actual", value: fmt(d.total_actual), color: C.success },
    {
      label: "Variance",
      value: fmt(d.total_actual - (d.total_budget || 0)),
      color: d.total_actual - (d.total_budget || 0) >= 0 ? C.success : C.danger,
    },
  ],
};

const KPIStrip = ({ reportType, data }) => {
  const cards = KPI_CONFIG[reportType]?.(data) ?? [];
  if (!cards.length) return null;
  return (
    <div
      style={{ display: "flex", gap: 14, flexWrap: "wrap", marginBottom: 24 }}
    >
      {cards.map((c, i) => (
        <div
          key={i}
          style={{
            flex: "1 1 130px",
            background: C.cardBg,
            borderRadius: 10,
            padding: "16px 18px",
            borderTop: `3px solid ${c.color}`,
            boxShadow: "0 1px 6px rgba(0,0,0,0.05)",
          }}
        >
          <div
            style={{
              fontSize: 11,
              color: C.muted,
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: 0.5,
              marginBottom: 6,
            }}
          >
            {c.label}
          </div>
          <div style={{ fontSize: 18, fontWeight: 800, color: c.color }}>
            {c.value}
          </div>
        </div>
      ))}
    </div>
  );
};

// ── Balance Sheet ─────────────────────────────────────────────────────────────
const BSSection = ({ title, items, total, tint }) => (
  <div style={{ marginBottom: 16 }}>
    <div
      style={{
        fontWeight: 700,
        color: C.accent,
        padding: "7px 0",
        borderBottom: `2px solid ${C.accentLight}`,
        marginBottom: 6,
        fontSize: 11,
        textTransform: "uppercase",
        letterSpacing: 0.5,
      }}
    >
      {title}
    </div>
    {items?.map((item, i) => (
      <div
        key={i}
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "6px 10px",
          backgroundColor: i % 2 === 0 ? tint : C.cardBg,
        }}
      >
        <span style={{ color: C.muted, fontSize: 13 }}>
          {item.code} — {item.name}
        </span>
        <span style={{ fontWeight: 600, fontSize: 13 }}>
          {fmt(item.balance)}
        </span>
      </div>
    ))}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "8px 10px",
        backgroundColor: tint,
        borderRadius: 6,
        marginTop: 4,
      }}
    >
      <span style={{ fontWeight: 700, fontSize: 13 }}>Total {title}</span>
      <span style={{ fontWeight: 800, fontSize: 14 }}>{fmt(total)}</span>
    </div>
  </div>
);

const TotalBar = ({ label, value, dark }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      padding: "12px 16px",
      backgroundColor: dark ? C.accent : C.accentLight,
      borderRadius: 8,
      marginTop: 8,
    }}
  >
    <span
      style={{ fontWeight: 700, fontSize: 14, color: dark ? "#fff" : C.text }}
    >
      {label}
    </span>
    <span
      style={{ fontWeight: 800, fontSize: 16, color: dark ? "#fff" : C.text }}
    >
      {fmt(value)}
    </span>
  </div>
);

const BalanceSheetView = ({ data }) =>
  !data ? null : (
    <div>
      {data.note && (
        <div
          style={{
            backgroundColor: "#FEF3C7",
            border: "1px solid #FDE68A",
            borderRadius: 8,
            padding: "10px 14px",
            marginBottom: 18,
            fontSize: 12,
            color: "#92400E",
          }}
        >
          ℹ️ {data.note}
        </div>
      )}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 28 }}>
        <div>
          <Divider label="Assets" />
          <BSSection
            title="Current Assets"
            items={data.assets?.current?.items}
            total={data.assets?.current?.total}
            tint="#EFF6FF"
          />
          {data.assets?.fixed?.items?.length > 0 && (
            <BSSection
              title="Fixed Assets"
              items={data.assets?.fixed?.items}
              total={data.assets?.fixed?.total}
              tint="#EFF6FF"
            />
          )}
          <TotalBar label="TOTAL ASSETS" value={data.assets?.total} dark />
        </div>
        <div>
          <Divider label="Liabilities & Equity" />
          <BSSection
            title="Current Liabilities"
            items={data.liabilities?.current?.items}
            total={data.liabilities?.current?.total}
            tint="#FEF2F2"
          />
          {data.liabilities?.long_term?.items?.length > 0 && (
            <BSSection
              title="Long-Term Liabilities"
              items={data.liabilities?.long_term?.items}
              total={data.liabilities?.long_term?.total}
              tint="#FEF2F2"
            />
          )}
          <BSSection
            title="Equity"
            items={data.equity?.items}
            total={data.equity?.total}
            tint="#ECFDF5"
          />
          <TotalBar
            label="TOTAL LIABILITIES + EQUITY"
            value={data.total_liabilities_and_equity}
            dark
          />
        </div>
      </div>
    </div>
  );

// ── Income Statement ──────────────────────────────────────────────────────────
const ISSection = ({ label, items, total, color }) => (
  <>
    <Divider label={label} />
    {items?.map((item, i) => (
      <div
        key={i}
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "6px 18px",
        }}
      >
        <span style={{ color: C.muted, fontSize: 13 }}>
          {item.code} — {item.name}
        </span>
        <span style={{ fontWeight: 500, fontSize: 13 }}>
          {fmt(item.balance)}
        </span>
      </div>
    ))}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "9px 10px",
        backgroundColor: color,
        borderRadius: 6,
        marginTop: 4,
      }}
    >
      <span style={{ fontWeight: 700, fontSize: 13, color: "#fff" }}>
        Total {label}
      </span>
      <span style={{ fontWeight: 800, fontSize: 14, color: "#fff" }}>
        {fmt(total)}
      </span>
    </div>
  </>
);

const IncomeStatementView = ({ data }) =>
  !data ? null : (
    <div style={{ maxWidth: 620, margin: "0 auto" }}>
      <ISSection
        label="Revenue"
        items={data.revenue?.items}
        total={data.revenue?.total}
        color={C.success}
      />
      <ISSection
        label="Cost of Goods Sold"
        items={data.cogs?.items}
        total={data.cogs?.total}
        color={C.danger}
      />
      <div
        style={{
          border: `2px solid ${C.accent}`,
          borderRadius: 10,
          padding: "14px 18px",
          display: "flex",
          justifyContent: "space-between",
          margin: "18px 0",
        }}
      >
        <span style={{ fontWeight: 700, fontSize: 15, color: C.accent }}>
          GROSS PROFIT
        </span>
        <span style={{ fontWeight: 800, fontSize: 17, color: C.accent }}>
          {fmt(data.gross_profit)}
        </span>
      </div>
      <ISSection
        label="Operating Expenses"
        items={data.operating_expenses?.items}
        total={data.operating_expenses?.total}
        color={C.warning}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "9px 10px",
          backgroundColor: C.purple,
          borderRadius: 6,
          marginBottom: 6,
        }}
      >
        <span style={{ fontWeight: 700, fontSize: 13, color: "#fff" }}>
          Operating Income
        </span>
        <span style={{ fontWeight: 800, fontSize: 14, color: "#fff" }}>
          {fmt(data.operating_income)}
        </span>
      </div>
      {data.other_expenses?.items?.length > 0 && (
        <ISSection
          label="Other Expenses"
          items={data.other_expenses?.items}
          total={data.other_expenses?.total}
          color={C.muted}
        />
      )}
      <div
        style={{
          padding: "16px 20px",
          backgroundColor: data.net_income >= 0 ? C.success : C.danger,
          borderRadius: 10,
          display: "flex",
          justifyContent: "space-between",
          marginTop: 18,
          color: "#fff",
        }}
      >
        <span style={{ fontWeight: 700, fontSize: 17 }}>NET INCOME</span>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontWeight: 800, fontSize: 22 }}>
            {fmt(data.net_income)}
          </div>
          <div style={{ fontSize: 12, opacity: 0.85 }}>
            Margin: {data.net_income_margin}%
          </div>
        </div>
      </div>
      {(data.tax_collected > 0 || data.discounts > 0) && (
        <div
          style={{
            marginTop: 10,
            fontSize: 12,
            color: C.muted,
            textAlign: "right",
          }}
        >
          Tax collected: {fmt(data.tax_collected)} · Discounts:{" "}
          {fmt(data.discounts)}
        </div>
      )}
    </div>
  );

// ── Trial Balance ─────────────────────────────────────────────────────────────
const TrialBalanceView = ({ data }) =>
  !data ? null : (
    <table style={S.table}>
      <thead>
        <tr>
          <th style={S.th}>Code</th>
          <th style={S.th}>Account</th>
          <th style={S.th}>Type</th>
          <th style={S.thR}>Debit</th>
          <th style={S.thR}>Credit</th>
        </tr>
      </thead>
      <tbody>
        {data.rows?.map((row, i) => (
          <tr
            key={i}
            style={{ backgroundColor: i % 2 === 0 ? C.rowAlt : C.cardBg }}
          >
            <td style={S.td}>{row.code}</td>
            <td style={S.td}>{row.name}</td>
            <td style={S.td}>
              <span
                style={{
                  fontSize: 11,
                  padding: "2px 8px",
                  borderRadius: 10,
                  backgroundColor: C.accentLight,
                  color: C.accent,
                  fontWeight: 600,
                }}
              >
                {row.type}
              </span>
            </td>
            <td style={S.tdR}>
              {row.total_debit > 0 ? fmt(row.total_debit) : "—"}
            </td>
            <td style={S.tdR}>
              {row.total_credit > 0 ? fmt(row.total_credit) : "—"}
            </td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr style={{ backgroundColor: C.accent }}>
          <td
            colSpan={3}
            style={{
              ...S.td,
              fontWeight: 700,
              color: "#fff",
              borderBottom: "none",
            }}
          >
            TOTALS
          </td>
          <td
            style={{
              ...S.tdR,
              fontWeight: 800,
              color: "#fff",
              borderBottom: "none",
            }}
          >
            {fmt(data.totals?.debit)}
          </td>
          <td
            style={{
              ...S.tdR,
              fontWeight: 800,
              color: "#fff",
              borderBottom: "none",
            }}
          >
            {fmt(data.totals?.credit)}
          </td>
        </tr>
        <tr>
          <td
            colSpan={5}
            style={{
              ...S.td,
              color: data.totals?.is_balanced ? C.success : C.danger,
              fontWeight: 700,
            }}
          >
            {data.totals?.is_balanced
              ? "✅ Balanced"
              : "❌ Not balanced — debits ≠ credits"}
          </td>
        </tr>
      </tfoot>
    </table>
  );

// ── General Ledger ────────────────────────────────────────────────────────────
const SRC = {
  order: { bg: "#ECFDF5", color: "#065F46" },
  expense: { bg: "#FEF2F2", color: "#991B1B" },
  earning: { bg: "#EFF6FF", color: "#1E40AF" },
  manual: { bg: "#F5F3FF", color: "#5B21B6" },
  depreciation: { bg: "#FFF7ED", color: "#C2410C" },
};

const LedgerView = ({ data }) =>
  !data ? null : (
    <table style={S.table}>
      <thead>
        <tr>
          <th style={S.th}>Date</th>
          <th style={S.th}>Ref</th>
          <th style={S.th}>Account</th>
          <th style={S.th}>Description</th>
          <th style={S.th}>Source</th>
          <th style={S.thR}>Debit</th>
          <th style={S.thR}>Credit</th>
          <th style={S.thR}>Balance</th>
        </tr>
      </thead>
      <tbody>
        {data.rows?.map((row, i) => {
          const sc = SRC[row.source] || { bg: "#F3F4F6", color: "#374151" };
          return (
            <tr
              key={i}
              style={{ backgroundColor: i % 2 === 0 ? C.rowAlt : C.cardBg }}
            >
              <td style={S.td}>{row.entry_date}</td>
              <td style={S.td}>{row.reference}</td>
              <td style={S.td}>
                <span style={{ fontSize: 11, color: C.muted }}>
                  {row.account_code}
                </span>{" "}
                {row.account_name}
              </td>
              <td style={{ ...S.td, color: C.muted, fontSize: 12 }}>
                {row.description}
              </td>
              <td style={S.td}>
                <span
                  style={{
                    fontSize: 11,
                    padding: "2px 8px",
                    borderRadius: 10,
                    backgroundColor: sc.bg,
                    color: sc.color,
                    fontWeight: 600,
                  }}
                >
                  {row.source}
                </span>
              </td>
              <td style={S.tdR}>{row.debit > 0 ? fmt(row.debit) : "—"}</td>
              <td style={S.tdR}>{row.credit > 0 ? fmt(row.credit) : "—"}</td>
              <td
                style={{
                  ...S.tdR,
                  fontWeight: 600,
                  color: row.running_balance >= 0 ? C.success : C.danger,
                }}
              >
                {fmt(row.running_balance)}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );

// ── AR / AP Aging ─────────────────────────────────────────────────────────────
const AGING_BUCKETS = [
  { key: "current", label: "Current", color: C.success },
  { key: "d1_30", label: "1-30 Days", color: C.warning },
  { key: "d31_60", label: "31-60 Days", color: "#F97316" },
  { key: "d61_90", label: "61-90 Days", color: "#EF4444" },
  { key: "d90plus", label: "90+ Days", color: "#991B1B" },
];

const AgingView = ({ data, type }) =>
  !data ? null : (
    <div>
      {AGING_BUCKETS.map((b) => {
        const bucket = data[b.key];
        if (!bucket?.items?.length) return null;
        return (
          <div key={b.key} style={{ marginBottom: 24 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "8px 12px",
                backgroundColor: b.color,
                borderRadius: 8,
                marginBottom: 8,
                color: "#fff",
              }}
            >
              <span style={{ fontWeight: 700, fontSize: 13 }}>{b.label}</span>
              <span style={{ fontWeight: 800 }}>{fmt(bucket.total)}</span>
            </div>
            <table style={{ ...S.table, fontSize: 12 }}>
              <thead>
                <tr>
                  <th style={S.th}>{type === "ar" ? "Customer" : "Vendor"}</th>
                  <th style={S.th}>Invoice/Bill #</th>
                  <th style={S.th}>Date</th>
                  <th style={S.th}>Due Date</th>
                  <th style={S.thR}>Total</th>
                  <th style={S.thR}>Balance Due</th>
                  <th style={S.thR}>Days Overdue</th>
                </tr>
              </thead>
              <tbody>
                {bucket.items.map((inv, i) => (
                  <tr
                    key={i}
                    style={{
                      backgroundColor: i % 2 === 0 ? C.rowAlt : C.cardBg,
                    }}
                  >
                    <td style={S.td}>
                      {type === "ar" ? inv.customer_name : inv.vendor_name}
                    </td>
                    <td style={S.td}>
                      {type === "ar" ? inv.invoice_number : inv.bill_number}
                    </td>
                    <td style={S.td}>
                      {type === "ar" ? inv.invoice_date : inv.bill_date}
                    </td>
                    <td style={S.td}>{inv.due_date}</td>
                    <td style={S.tdR}>{fmt(inv.total_amount)}</td>
                    <td style={{ ...S.tdR, fontWeight: 600, color: b.color }}>
                      {fmt(inv.balance_due)}
                    </td>
                    <td
                      style={{
                        ...S.tdR,
                        color: inv.days_overdue > 0 ? C.danger : C.success,
                      }}
                    >
                      {inv.days_overdue > 0
                        ? `${inv.days_overdue}d`
                        : "Current"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      })}
    </div>
  );

// ── Budget vs Actual ──────────────────────────────────────────────────────────
const BudgetVsActualView = ({ data }) =>
  !data ? null : (
    <table style={S.table}>
      <thead>
        <tr>
          <th style={S.th}>Code</th>
          <th style={S.th}>Account</th>
          <th style={S.th}>Type</th>
          <th style={S.thR}>Budget</th>
          <th style={S.thR}>Actual</th>
          <th style={S.thR}>Variance</th>
          <th style={S.thR}>Var %</th>
        </tr>
      </thead>
      <tbody>
        {data.rows?.map((row, i) => (
          <tr
            key={i}
            style={{ backgroundColor: i % 2 === 0 ? C.rowAlt : C.cardBg }}
          >
            <td style={S.td}>{row.account_code}</td>
            <td style={S.td}>{row.account_name}</td>
            <td style={S.td}>
              <span
                style={{
                  fontSize: 11,
                  padding: "2px 8px",
                  borderRadius: 10,
                  backgroundColor: C.accentLight,
                  color: C.accent,
                  fontWeight: 600,
                }}
              >
                {row.account_type}
              </span>
            </td>
            <td style={S.tdR}>{fmt(row.budget_total)}</td>
            <td style={S.tdR}>{fmt(row.actual)}</td>
            <td
              style={{
                ...S.tdR,
                fontWeight: 600,
                color: row.variance >= 0 ? C.success : C.danger,
              }}
            >
              {fmt(row.variance)}
            </td>
            <td
              style={{
                ...S.tdR,
                fontWeight: 600,
                color: row.variance_pct >= 0 ? C.success : C.danger,
              }}
            >
              {fmtPct(row.variance_pct)}
            </td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr style={{ backgroundColor: C.accent }}>
          <td
            colSpan={3}
            style={{
              ...S.td,
              color: "#fff",
              fontWeight: 700,
              borderBottom: "none",
            }}
          >
            TOTALS
          </td>
          <td
            style={{
              ...S.tdR,
              color: "#fff",
              fontWeight: 800,
              borderBottom: "none",
            }}
          >
            {fmt(data.total_budget)}
          </td>
          <td
            style={{
              ...S.tdR,
              color: "#fff",
              fontWeight: 800,
              borderBottom: "none",
            }}
          >
            {fmt(data.total_actual)}
          </td>
          <td
            colSpan={2}
            style={{
              ...S.tdR,
              color: "#fff",
              fontWeight: 800,
              borderBottom: "none",
            }}
          >
            {fmt(data.total_actual - (data.total_budget || 0))}
          </td>
        </tr>
      </tfoot>
    </table>
  );

// ── Cost Centers ──────────────────────────────────────────────────────────────
const CostCentersView = ({ data }) =>
  !data ? null : (
    <div>
      {data.centers?.map((cc, ci) => (
        <div key={ci} style={{ marginBottom: 24 }}>
          <div
            style={{
              padding: "10px 14px",
              backgroundColor: C.accent,
              borderRadius: 8,
              color: "#fff",
              fontWeight: 700,
              marginBottom: 8,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <span>
              {cc.code} — {cc.name}
            </span>
            <span>
              DR {fmt(cc.total_debit)} / CR {fmt(cc.total_credit)}
            </span>
          </div>
          <table style={{ ...S.table, fontSize: 12 }}>
            <thead>
              <tr>
                <th style={S.th}>Account</th>
                <th style={S.th}>Type</th>
                <th style={S.thR}>Debit</th>
                <th style={S.thR}>Credit</th>
              </tr>
            </thead>
            <tbody>
              {cc.lines?.map((l, i) => (
                <tr
                  key={i}
                  style={{ backgroundColor: i % 2 === 0 ? C.rowAlt : C.cardBg }}
                >
                  <td style={S.td}>
                    {l.account_code} — {l.account_name}
                  </td>
                  <td style={S.td}>{l.account_type}</td>
                  <td style={S.tdR}>{l.debit > 0 ? fmt(l.debit) : "—"}</td>
                  <td style={S.tdR}>{l.credit > 0 ? fmt(l.credit) : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );

// ── Report Router ─────────────────────────────────────────────────────────────
const ReportView = ({ type, data }) =>
  ({
    income_statement: <IncomeStatementView data={data} />,
    balance_sheet: <BalanceSheetView data={data} />,
    trial_balance: <TrialBalanceView data={data} />,
    ledger: <LedgerView data={data} />,
    ar_aging: <AgingView data={data} type="ar" />,
    ap_aging: <AgingView data={data} type="ap" />,
    budget_vs_actual: <BudgetVsActualView data={data} />,
    cost_centers: <CostCentersView data={data} />,
  }[type] ?? null);

// ── Email Modal ───────────────────────────────────────────────────────────────
const EmailModal = ({ onClose, onSend }) => {
  const [email, setEmail] =
    [useState(""), useState("")][0] !== undefined
      ? [useState(""), useState("")]
      : [useState(""), useState("")];
  // simplified
  const [em, setEm] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    if (!em) return;
    setBusy(true);
    await onSend(em, msg);
    setBusy(false);
    onClose();
  };
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.45)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          background: C.cardBg,
          borderRadius: 14,
          padding: 32,
          width: 440,
          boxShadow: "0 24px 64px rgba(0,0,0,0.22)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 22,
          }}
        >
          <h3
            style={{ margin: 0, color: C.text, fontSize: 16, fontWeight: 700 }}
          >
            Send Report via Email
          </h3>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              color: C.muted,
              fontSize: 20,
            }}
          >
            <MdClose />
          </button>
        </div>
        <label style={S.label}>Recipient *</label>
        <input
          type="email"
          value={em}
          onChange={(e) => setEm(e.target.value)}
          style={{ ...S.input, marginBottom: 14 }}
          placeholder="example@company.com"
        />
        <label style={S.label}>Message (optional)</label>
        <textarea
          value={msg}
          onChange={(e) => setMsg(e.target.value)}
          style={{
            ...S.input,
            height: 80,
            resize: "vertical",
            marginBottom: 20,
          }}
        />
        <div style={{ display: "flex", gap: 10 }}>
          <Btn onClick={send} disabled={busy || !em}>
            {busy ? "Sending…" : "Send"}
          </Btn>
          <Btn onClick={onClose} color={C.muted}>
            Cancel
          </Btn>
        </div>
      </div>
    </div>
  );
};

// ── Main Page ─────────────────────────────────────────────────────────────────
const FinancialReports = () => {
  const [reportType, setReportType] = useState("income_statement");
  const [dateFrom, setDateFrom] = useState(firstOfYear());
  const [dateTo, setDateTo] = useState(todayStr());
  const [budgetYear, setBudgetYear] = useState(String(now().getFullYear()));
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showEmail, setShowEmail] = useState(false);
  const [toast, setToast] = useState(null);
  const printRef = useRef();

  const showToast = (msg, isError = false) => {
    setToast({ msg, isError });
    setTimeout(() => setToast(null), 3500);
  };

  const generate = useCallback(
    async (type = reportType, from = dateFrom, to = dateTo) => {
      setError("");
      setData(null);
      setLoading(true);
      try {
        let params = {};
        if (
          [
            "income_statement",
            "balance_sheet",
            "trial_balance",
            "ledger",
          ].includes(type)
        ) {
          params = { date_from: from, date_to: to };
        } else if (type === "budget_vs_actual") {
          params = { year: budgetYear };
        } else if (["ar_aging", "ap_aging"].includes(type)) {
          params = {}; // uses today internally
        } else if (type === "cost_centers") {
          params = { date_from: from, date_to: to };
        }
        const res = await api.report(type, params);
        setData(res.data.data);
      } catch (e) {
        setError(e?.response?.data?.error || "Failed to load report");
      } finally {
        setLoading(false);
      }
    },
    [reportType, dateFrom, dateTo, budgetYear]
  );

  useEffect(() => {
    generate(reportType, dateFrom, dateTo);
  }, [reportType]);

  const handleExport = async () => {
    try {
      const res = await api.exportXlsx(reportType, dateFrom, dateTo);
      const blob = await res.blob();
      Object.assign(document.createElement("a"), {
        href: URL.createObjectURL(blob),
        download: `${reportType}_${dateFrom}_${dateTo}.xlsx`,
      }).click();
    } catch {
      showToast("Export failed", true);
    }
  };

  const handleEmail = async (email, message) => {
    try {
      await api.email({
        report_type: reportType,
        date_from: dateFrom,
        date_to: dateTo,
        email,
        message,
      });
      showToast("Report sent!");
    } catch {
      showToast("Failed to send", true);
    }
  };

  const handlePrint = () => {
    const w = window.open("", "_blank");
    w.document.write(
      `<html><head><title>${reportType}</title><style>body{font-family:Arial,sans-serif;padding:20px}*{box-sizing:border-box}</style></head><body>${printRef.current?.innerHTML}</body></html>`
    );
    w.document.close();
    w.print();
  };

  const needsDates = !["ar_aging", "ap_aging"].includes(reportType);
  const needsBudgetYr = reportType === "budget_vs_actual";
  const coreGroup = TABS.filter((t) => t.group === "core");
  const advGroup = TABS.filter((t) => t.group === "advanced");

  return (
    <div style={S.page}>
      {toast && (
        <div
          style={{
            position: "fixed",
            top: 20,
            right: 20,
            zIndex: 9999,
            backgroundColor: toast.isError ? C.danger : C.success,
            color: "#fff",
            padding: "12px 22px",
            borderRadius: 8,
            fontWeight: 600,
            boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
            fontSize: 14,
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          {toast.isError ? <MdWarning /> : <MdCheckCircle />} {toast.msg}
        </div>
      )}

      {/* Header */}
      <div
        style={{
          ...S.card,
          backgroundColor: C.accent,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 14,
          borderRadius: 14,
        }}
      >
        <div>
          <h1
            style={{ fontSize: 20, fontWeight: 700, color: "#fff", margin: 0 }}
          >
            📊 Financial Reports
          </h1>
          <p style={{ color: C.chipOnDark, margin: "4px 0 0", fontSize: 12 }}>
            {needsDates ? `${dateFrom} → ${dateTo}` : `As of ${todayStr()}`}
            {data?.source && <SourceBadge source={data.source} />}
          </p>
        </div>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <Btn
            onClick={() => generate()}
            disabled={loading}
            color={C.accentHover}
            hoverColor="#111C28"
          >
            <MdRefresh
              style={{
                animation: loading ? "spin 0.9s linear infinite" : "none",
              }}
            />
            {loading ? "Loading…" : "Refresh"}
          </Btn>
          <Btn onClick={handleExport} color="#0E7C5A" hoverColor="#0A6148">
            <MdDownload /> Export
          </Btn>
          <Btn onClick={handlePrint} color="#4B3DA8" hoverColor="#3B2E88">
            <MdPrint /> Print
          </Btn>
          <Btn
            onClick={() => setShowEmail(true)}
            color="#A0610A"
            hoverColor="#7D4C08"
          >
            <MdEmail /> Email
          </Btn>
        </div>
      </div>

      {/* Filters */}
      <div style={S.card}>
        <div
          style={{
            display: "flex",
            gap: 14,
            flexWrap: "wrap",
            alignItems: "flex-end",
          }}
        >
          {needsDates && (
            <>
              <div style={{ flex: "1 1 150px" }}>
                <label style={S.label}>From</label>
                <input
                  type="date"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                  style={S.input}
                />
              </div>
              <div style={{ flex: "1 1 150px" }}>
                <label style={S.label}>To</label>
                <input
                  type="date"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                  style={S.input}
                />
              </div>
              <div style={{ flex: "2 1 260px" }}>
                <label style={S.label}>Quick Range</label>
                <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                  {QUICK_RANGES.map((r, i) => (
                    <button
                      key={i}
                      onClick={() => {
                        setDateFrom(r.from);
                        setDateTo(r.to);
                      }}
                      style={{
                        padding: "7px 12px",
                        border: `1px solid ${C.border}`,
                        borderRadius: 6,
                        cursor: "pointer",
                        fontSize: 12,
                        fontWeight: 600,
                        backgroundColor: "#F8F9FB",
                        color: C.muted,
                      }}
                    >
                      {r.label}
                    </button>
                  ))}
                </div>
              </div>
            </>
          )}
          {needsBudgetYr && (
            <div style={{ flex: "1 1 120px" }}>
              <label style={S.label}>Year</label>
              <input
                type="number"
                value={budgetYear}
                onChange={(e) => setBudgetYear(e.target.value)}
                style={S.input}
                min="2000"
                max="2100"
              />
            </div>
          )}
          <Btn
            onClick={() => generate(reportType, dateFrom, dateTo)}
            disabled={loading}
            style={{ padding: "9px 28px" }}
          >
            <MdSync
              style={{
                animation: loading ? "spin 0.9s linear infinite" : "none",
              }}
            />
            {loading ? "Loading…" : "Generate"}
          </Btn>
        </div>
      </div>

      {/* Tabs — two rows: Core + Advanced */}
      <div style={{ marginBottom: 18 }}>
        <div
          style={{
            display: "flex",
            gap: 2,
            borderBottom: `2px solid ${C.accentLight}`,
          }}
        >
          {coreGroup.map((tab) => (
            <button
              key={tab.key}
              onClick={() => !loading && setReportType(tab.key)}
              style={{
                padding: "10px 18px",
                border: "none",
                cursor: loading ? "not-allowed" : "pointer",
                fontSize: 13,
                fontWeight: 600,
                backgroundColor: "transparent",
                borderBottom:
                  reportType === tab.key
                    ? `3px solid ${C.accent}`
                    : "3px solid transparent",
                color: reportType === tab.key ? C.accent : C.muted,
                display: "flex",
                alignItems: "center",
                gap: 6,
                transition: "all 0.15s",
                marginBottom: -2,
              }}
            >
              {tab.icon} {tab.label}
            </button>
          ))}
        </div>
        <div
          style={{
            display: "flex",
            gap: 2,
            borderBottom: `2px solid ${C.accentLight}`,
            marginTop: 2,
          }}
        >
          <span
            style={{
              padding: "8px 12px",
              fontSize: 11,
              fontWeight: 700,
              color: C.muted,
              textTransform: "uppercase",
              letterSpacing: 0.5,
              alignSelf: "center",
            }}
          >
            Advanced
          </span>
          {advGroup.map((tab) => (
            <button
              key={tab.key}
              onClick={() => !loading && setReportType(tab.key)}
              style={{
                padding: "10px 18px",
                border: "none",
                cursor: loading ? "not-allowed" : "pointer",
                fontSize: 13,
                fontWeight: 600,
                backgroundColor: "transparent",
                borderBottom:
                  reportType === tab.key
                    ? `3px solid ${C.purple}`
                    : "3px solid transparent",
                color: reportType === tab.key ? C.purple : C.muted,
                display: "flex",
                alignItems: "center",
                gap: 6,
                transition: "all 0.15s",
                marginBottom: -2,
              }}
            >
              {tab.icon} {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      <div ref={printRef}>
        {loading && (
          <div style={{ ...S.card, textAlign: "center", padding: 60 }}>
            <MdSync
              style={{
                fontSize: 36,
                color: C.accent,
                animation: "spin 0.9s linear infinite",
              }}
            />
            <div
              style={{
                fontWeight: 700,
                color: C.text,
                fontSize: 15,
                marginTop: 14,
              }}
            >
              Building report…
            </div>
            <div style={{ fontSize: 12, color: C.muted, marginTop: 4 }}>
              Querying source data
            </div>
          </div>
        )}
        {!loading && error && (
          <div
            style={{
              ...S.card,
              backgroundColor: "#FEF2F2",
              color: C.danger,
              border: `1px solid #FECACA`,
              display: "flex",
              alignItems: "center",
              gap: 10,
            }}
          >
            <MdWarning style={{ fontSize: 20, flexShrink: 0 }} /> {error}
          </div>
        )}
        {!loading && !error && data && (
          <div style={S.card}>
            <KPIStrip reportType={reportType} data={data} />
            <ReportView type={reportType} data={data} />
          </div>
        )}
      </div>

      {showEmail && (
        <EmailModal onClose={() => setShowEmail(false)} onSend={handleEmail} />
      )}
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

export default FinancialReports;
